import { render, staticRenderFns } from "./SubjectLabelCategory.vue?vue&type=template&id=cb818640"
import script from "@/views/SubjectLabelCategory/SubjectLabelCategory.ts?vue&type=script&lang=ts&external"
export * from "@/views/SubjectLabelCategory/SubjectLabelCategory.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/SubjectLabelCategory/SubjectLabelCategory.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports